import { Component } from '@angular/core';

@Component({
  selector: 'app-loader-com',
  templateUrl: 'loader.com.html',
  styleUrls: ['loader.scss']
})

export class LoaderComponent {}



// WEBPACK FOOTER //
// ./src/app/com/loader/loader.com.ts